import signalr from 'BASE/common/signalrAdapter';
import websiteInfoUtil from 'BASE/common/util/util.websiteInfo';
import userInfo_component from 'BASE/components/userInfo.component'; //權限等狀態初始化須使用
import BetAwardNotifyComponent from 'BASE/components/notification/betAwardNotify.component';
import ToastNotificationComponent from 'BASE/components/notification/toastNotification.component';
import { offAllInput } from 'BASE/plugins/autoCompletePlugin';
import StreamingNotificationComponent from 'OL/views/Notification/StreamingNotification.vue';
export default {
    mixins: [websiteInfoUtil, userInfo_component],
    components: {
        BetAwardNotifyComponent,
        ToastNotificationComponent,
        StreamingNotificationComponent,
    },
    data: function () {
        return {
            appClass: '',
            notificationCount: 1,  
        }
    },
    computed:{
        skinClass(){
            if(!this.CanUseSkin){
                return '';
            }
            return this.$store.state.userinfo.skinClass;
        },

        CanUseSkin(){
            let val = this.$route.name;
            let _skinHandle = ['Bet','ComboBet'];

            if( val != null && _skinHandle.find((item) => val==item )){
                return true;
            }
            return false;
        },

    },
   
    methods:{
        IEBrowserAlert(){
            let _this = this;
            if (window.document.documentMode) {
                _this.$dialog.get("ieAlert").show();
            }
        }
    },
    created() {
        let _this = this;
        signalr.init();
        window.addEventListener("load", function(){
            _this.IEBrowserAlert();
        });
    },
    updated(){
        this.$nextTick(function () {
            // 關閉當下所有input的自動填入，減少大部分瀏覽器自動填入狀況，剩下部分手動使用autoCompletePlugin排除
            offAllInput(this.$el);
        });        
    },
};